import { Component } from "@angular/core";
import { MeetingAgendaItemComponent } from "@org-common/lib/meetings/meeting-agenda-component-registry";
import { TourIdentifier } from "../../../tours/tour-identifier.enum";

@MeetingAgendaItemComponent("adapt-record-annual-objectives-agenda-item")
@Component({
    selector: "adapt-record-annual-objectives-agenda-item",
    templateUrl: "./record-annual-objectives-agenda-item.component.html",
    standalone: false,
})
export class RecordAnnualObjectivesAgendaItemComponent {
    public readonly PageActivationTours = [TourIdentifier.RecordObjectivesFeatureTour];
}
